@if (visible) {
  <div class="modal_customer"
    >
    @if (cbmData != null) {
      <div class="modal_customer_body">
        <div class="_container">
          <div class="cbm-details">
            <div class="details-container">
              <div class="cbm-name">{{ cbmData['contractor']['cbmName'] }} </div>
              <div class="cbm-rating">
                <!-- <img    class="star"
                alt="star-icon"
                *ngFor=" let x of [].constructor(getRating())"
                src="assets/img/icons/cb_star_active.svg">
                <img    class="star"
                  alt="star-icon"
                  *ngFor=" let x of [].constructor(5-getRating())"
                  src="assets/img/icons/cb_star_inactive.svg">
                  <span style="margin-left: 4px">
                    {{ cbmData['contractor']['rating'] | number:'1.1' }}
                  </span>
                  <span style="margin-left: 4px">
                    ( {{ cbmData['feedback'].length }}  Reviews)
                  </span> -->
                  <app-starratemodal  [rating]="getRatingValue(cbmData['contractor']['rating'])" [reviews]="cbmData['feedback'].length" [starOnly]="false"></app-starratemodal>
                </div>
                <br>
                  <div class="data-label">PCAB License Number</div>
                  <div class="data-item">{{ cbmData['contractor']['pcabNo'] }}</div>
                  <br>
                    <div class="data-label">Residential/ Non-residential/ Mixed</div>
                    <div class="data-item">{{ cbmData['contractor']['class'] | titlecase}}</div>
                    <br>
                    <div class="data-label">Services Offered</div>
                    <div class="data-item services" style="width: 460px;">
                      {{ cbmData['servicetype']['name'] }}
                    </div>
                    <br>
                      <div class="data-label">Service Areas</div>
                      <div class="data-item cities"
                        [ngClass]="{ 'expand-cities' : expandCities }">
                        @for (item of cbmData['city']; track item; let index = $index) {
                          {{ item['value'] | titlecase }}{{ index+1 < cbmData['city'].length ? ",":"" }}
                        }
                      </div>
                      <div class="view-all"
                        (click)="expandCities = !expandCities">
                        {{ expandCities ? 'Show less':'See More' }}
                      </div>
                      <br>
                    <div class="d-flex flex-row justify-content-start justify-content-lg-start
                                justify-content-xl-start
                                justify-content-md-center justify-content-sm-center  "
                          style="width: 100%;">
                          <button class="button button-active" (click)="select()">Select contractor</button>
                        </div>
                        <br>
                          <br>
                          </div>
                        </div>
                        <div class="cbm-reviews">
                          <div class="modal_customer_close" (click)="dismiss()">
                            <img src="assets/img/icons/modal_close.svg"
                              alt="close-icon"/>
                            </div>
                            <div class="review-header">Customer Reviews</div>
                            <br>
                              <div class="review-container">
                                <div class="d-flex flex-xl-row flex-lg-row align-items-xl-center flex-md-column flex-sm-column flex-column justify-content-sm-start">
                                  Sort By
                                  <div style="width: 10px;"></div>
                                  <select-cst [width]="'280px'"
                                    [items]="['Rating','Most Recent']"
                                    [selectedItem]="sortType"
                                    [placeHolder]="'Select Option'"
                                    (itemSelected)="sortType = $event">
                                  </select-cst>
                                </div>
                                <div class="review-list">
                                  @if (cbmData['feedback'].length>0) {
                                    @for (item of getReviews(sortType); track item; let index = $index) {
                                      <div class="review-item">
                                        <div class="review-item-stars">
                                          <!-- <img    class="star"
                                          alt="star-icon"
                                          *ngFor=" let x of [].constructor(computeRating(item))"
                                          src="assets/img/icons/cb_star_active.svg">
                                          <img    class="star"
                                            alt="star-icon"
                                            *ngFor=" let x of [].constructor(5-computeRating(item))"
                                            src="assets/img/icons/cb_star_inactive.svg"> -->
                                            <app-starratemodal [rating]="computeRating(item)" [reviews]="cbmData['feedback'].length" [starOnly]="true"></app-starratemodal>
                                          </div>
                                          <div class="review-item-message">
                                            {{ item['comment'] }}
                                          </div>
                                          <div class="review-item-tags">
                                          </div>
                                          <div class="review-item-user">
                                            <div>{{ hideName( item['user']) }}</div>
                                            <div>{{ item['date_created'] }}</div>
                                          </div>
                                        </div>
                                      }
                                    }
                                    @if (cbmData['feedback'].length == 0) {
                                      <div class="no-review">
                                        This contractor has no reviews yet
                                      </div>
                                    }
                                    @if (cbmData['feedback'].length>0) {
                                      <button class="button button-default text-center"
                                        (click)="viewAll()"
                                        >
                                        View All Reviews
                                      </button>
                                    }
                                    <br>
                                      <br>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
